module.exports = "//static.hsappstatic.net/ContentUtils/static-1.60506/img/choiceButtons/no-fill-rounded.svg"